/**
 * FileUploadPanel React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Typography from "@material-ui/core/Typography/Typography";
import CircularProgress from '@material-ui/core/CircularProgress';
import Dropzone from 'react-dropzone';


/**
 * FileUploadPanel allows to upload files
 *
 * @author Jens Gruschel
 */
export class FileUploadPanel extends React.Component {

    render() {

        const { classes } = this.props;

        if (this.props.busy) {

            return <div className={classes.progresspanel}>
                <CircularProgress className={classes.progress} />
            </div>;
        }
        else {

            return <div className={classes.dropzone}>
                <Dropzone onDrop={this.props.onDrop} disabled={this.props.disabled}>
                    <Typography component="p" className={classes.dropzoneText}>
                        {this.props.children}
                    </Typography>
                </Dropzone>
            </div>;
        }
    }
}

FileUploadPanel.propTypes = {
    onDrop: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    busy: PropTypes.bool
};

const styles = {
    dropzone: {
        display: "inline-block",
        cursor: "pointer"
    },
    dropzoneText: {
        pointerEvents: "none",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textAlign: "center"
    },
    progresspanel: {
        display: "inline-block",
        width: 200,
        height: 200
    },
    progress: {
        display: "block",
        margin: "80px auto"
    }
};

export default withStyles(styles)(FileUploadPanel);
